import PropTypes from "prop-types";
import { Component } from "react";
import Alert from "react-bootstrap/Alert";
import Button from "react-bootstrap/Button";
import ReactGA from "react-ga4";
import { Link } from "react-router-dom";

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static propTypes = {
    children: PropTypes.any,
  };

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // You can also log the error to an error reporting service
    //logErrorToMyService(error, errorInfo)
    ReactGA.exception({
      description: error.message,
      fatal: true,
    });
  }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return (
        <Alert className="m-4" variant="danger">
          <h4>An error occurred</h4>
          <p>Something went wrong and our team has been automatically notified.</p>
          <p>You may want to try a private tab or try a different web browser.</p>
          <p className="mb-0">
            You can also <Link to="/bug-report">submit a bug report</Link> or email us at{" "}
            <Link to="mailto:bugreport@edhrec.com">bugreport@edhrec.com</Link>.
          </p>
        </Alert>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
